import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { IntroSection } from './components/IntroSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { MomentSection } from './components/MomentSection';
import { QuotesSection } from './components/QuotesSection';
import { BookContentSection } from './components/BookContentSection';
import { WhyItMattersSection } from './components/WhyItMattersSection';
import { PricingSection } from './components/PricingSection';
import { FromTheAuthorsSection } from './components/FromTheAuthorsSection';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
import { SocialProofNotification } from './components/SocialProofNotification';
import { ChristmasDecorations } from './components/ChristmasDecorations';
export function App() {
  return <div className="w-full min-h-screen bg-bttf-bg text-bttf-text relative" data-id="element-0">
      <ChristmasDecorations data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <IntroSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />
        <MomentSection data-id="element-7" />
        <QuotesSection data-id="element-8" />
        <BookContentSection data-id="element-9" />
        <WhyItMattersSection data-id="element-10" />
        <PricingSection data-id="element-11" />
        <FromTheAuthorsSection data-id="element-12" />
        <CallToAction data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <SocialProofNotification data-id="element-15" />
    </div>;
}